import React from 'react';
import { CTAButton } from './ui/CTAButton';
export function OfferSection() {
  const includes = ['2.5 horas de entrenamiento experiencial con Jaime Nieto', 'Metodología probada en 9 países y más de 12,000 personas entrenadas', 'Rompimiento de tabla — tu límite, físicamente destruido', 'Comunidad de personas comprometidas con su transformación', 'Presencial · En español · En Miami', 'Una impronta que llevas contigo para siempre'];
  return <section id="oferta" className="py-24 px-4 bg-gray-50 text-[#1a1a2e]" data-id="element-112">
      <div className="max-w-4xl mx-auto" data-id="element-113">
        <div className="text-center mb-12" data-id="element-114">
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#5B2D8E] mb-6" data-id="element-115">
            Tu lugar por $5
          </h2>
          <div className="text-lg md:text-xl text-gray-700 space-y-4 max-w-2xl mx-auto" data-id="element-116">
            <p data-id="element-117">
              En honor al Mes de la Mujer, abrimos 100 cupos para la Noche de
              Impacto en Miami por solo $5.
            </p>
            <p className="font-bold" data-id="element-118">
              No es el precio normal de esta experiencia.
            </p>
            <p data-id="element-119">
              Es un gesto de nuestra parte para que ningún límite — ni siquiera
              económico — te impida estar ahí.
            </p>
            <p className="font-bold text-[#1a1a2e]" data-id="element-120">
              Pero son solo 100 lugares.
            </p>
            <p className="font-bold text-[#1a1a2e]" data-id="element-121">
              Y cuando se acaben, se acaben.
            </p>
          </div>
        </div>

        <div className="bg-white rounded-[2rem] shadow-2xl overflow-hidden border border-gray-100" data-id="element-122">
          {/* Urgency Banner */}
          <div className="bg-red-50 border-b border-red-100 p-6 text-center" data-id="element-123">
            <h3 className="text-red-600 font-bold text-xl mb-2 flex items-center justify-center gap-2" data-id="element-124">
              <span data-id="element-125">⚠️</span> ATENCIÓN
            </h3>
            <p className="text-red-800 font-medium" data-id="element-126">
              ⚠️ Esta oferta de $5 es exclusiva para el Mes de la Mujer · Solo
              100 cupos · Oferta termina el 15 de marzo
            </p>
          </div>

          <div className="p-8 md:p-12" data-id="element-127">
            <h4 className="text-2xl font-bold mb-6" data-id="element-128">
              Lo que incluye tu lugar:
            </h4>

            <ul className="space-y-4 mb-10" data-id="element-129">
              {includes.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-130">
                  <span className="text-green-500 text-xl shrink-0" data-id="element-131">✅</span>
                  <span className="text-gray-700 text-lg" data-id="element-132">{item}</span>
                </li>)}
            </ul>

            <div className="bg-gray-50 rounded-2xl p-8 text-center mb-8 border border-gray-200" data-id="element-133">
              <p className="text-gray-500 text-lg line-through mb-2" data-id="element-134">
                Valor real: $50
              </p>
              <p className="text-3xl md:text-4xl font-black text-[#5B2D8E]" data-id="element-135">
                Hoy, Mes de la Mujer:{' '}
                <span className="text-[#F5A623] text-5xl md:text-6xl" data-id="element-136">$5</span>
              </p>
            </div>

            <div className="text-center flex flex-col items-center" data-id="element-137">
              <CTAButton className="w-full md:w-auto text-xl md:text-2xl py-5 px-10 mb-2" data-id="element-138">
                🔥 RESERVA TU LUGAR
              </CTAButton>
              <p className="text-sm md:text-base text-[#F5A623] font-medium mb-8" data-id="element-139">
                $50 → $5 · 90% OFF · Solo por el Mes de la Mujer
              </p>

              <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-sm text-gray-500 bg-gray-50 py-3 px-6 rounded-full" data-id="element-140">
                <span className="flex items-center gap-1" data-id="element-141">
                  ✅ Pago seguro vía Square
                </span>
                <span className="flex items-center gap-1" data-id="element-142">
                  ✅ Confirmación inmediata por email
                </span>
                <span className="flex items-center gap-1" data-id="element-143">
                  ✅ Solo 100 cupos · No hay lista de espera
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}